'use es6';

import Activities from '../models/Activities';
import { REQUESTED_PERFORMANCE_DATA_CHECK, REQUESTED_PERFORMANCE_DATA_CHECK_FAILED, RECIEVED_PERFORMANCE_DATA_CHECK } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new Activities(), action) => {
  switch (action.type) {
    case REQUESTED_PERFORMANCE_DATA_CHECK:
      return state.set('status', RequestStatus.PENDING);
    case RECIEVED_PERFORMANCE_DATA_CHECK:
      return action.payload.data;
    case REQUESTED_PERFORMANCE_DATA_CHECK_FAILED:
      return state.set('status', RequestStatus.FAILED);
    default:
      return state;
  }
});